export default {
  App: {
    App: {
      ":global": {
        body: {
          background: "#fdfdfd",
        },
      },
    },
  },
  Categories: {

  },
  Board: {

  },
  Profile: {

  },
  Thread: {

  },
}



// WEBPACK FOOTER //
// ./src/themes/light.js